export const FETCH_TOP_MOVIE_REQUEST = 'FETCH_TOP_MOVIE_REQUEST'
export const FETCH_TOP_MOVIE_SUCCESS = 'FETCH_TOP_MOVIE_SUCCESS'
export const FETCH_TOP_MOVIE_FAILURE = 'FETCH_TOP_MOVIE_FAILURE'